import { useEffect } from 'react';
import { useApiContext, useGetFullInfo } from 'react-easyrocket';
import { smarticoSetUserData } from 'src/utils/smartico';

export const useSetSmarticoUser = () => {
  const { fullInfo, isSuccess } = useGetFullInfo();
  const { isAuthenticated } = useApiContext();

  useEffect(() => {
    if (isAuthenticated && fullInfo) {
      smarticoSetUserData(fullInfo?.id, fullInfo?.language);
    }
  }, [isAuthenticated, isSuccess]);
};
